import {
	Box,
	FormControl,
	IconButton,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";

import {
	AddRounded,
	DeleteOutlineRounded,
	DoneRounded,
	EditRounded,
} from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import APIContext from "../../context/APIContext";
import DropdownInput from "../reusable/DropdownInput";
import TextInputField from "../reusable/TextInputField";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
		padding: 0,
		textAlign: "center",
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12,
		padding: 0,
		textAlign: "center",
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));

const ScrapPaymentsTable = ({ setReceivedPayments, receivedPayments }) => {
	let defaultPayRecord = {
		serial: "",
		payId: "",
		payType: "",
		amount: "",
	};

	const [payRecord, setPayRecord] = React.useState(defaultPayRecord);
	//  onChange function for the form values
	const handleChange = (prop) => (event) => {
		setPayRecord({ ...payRecord, [prop]: event.target.value });
		console.log(payRecord);
	};

	const handleAddRecord = () => {
		setReceivedPayments((receivedPayments) => [...receivedPayments, payRecord]);
		setPayRecord(defaultPayRecord);
	};

	const handleDeleteRecord = (payId) => {
		setReceivedPayments(
			receivedPayments.filter((record) => record.payId !== payId)
		);
		setPayRecord(defaultPayRecord);
	};

	let [editting, setEditting] = useState(false);
	const handleEditRecord = (payId) => {
		setPayRecord(receivedPayments.find((record) => record.payId === payId));
		setEditting(true);
	};

	const handleSaveEdit = (payId) => {
		setPayRecord(receivedPayments.find((record) => record.payId === payId));
		setReceivedPayments(
			receivedPayments.filter((record) => record.payId !== payId)
		);
		setReceivedPayments((receivedPayments) => [...receivedPayments, payRecord]);
		setPayRecord(defaultPayRecord);
		setEditting(false);
	};

	let { payType } = useContext(APIContext);

	return (
		<>
			<TableContainer
				sx={{ height: 160, border: "1px solid gray", borderRadius: "5px" }}
			>
				<Table>
					<TableHead>
						<TableRow>
							<StyledTableCell>S#</StyledTableCell>
							<StyledTableCell>PayId</StyledTableCell>
							<StyledTableCell>Pay Tpe Name</StyledTableCell>
							<StyledTableCell>Amount</StyledTableCell>

							<StyledTableCell></StyledTableCell>
						</TableRow>
						<TableRow>
							<StyledTableCell>
								<TextInputField
									value={payRecord.serial}
									onChange={handleChange("serial")}
								/>
							</StyledTableCell>
							<StyledTableCell>
								<TextInputField
									value={payRecord.payId}
									onChange={handleChange("payId")}
								/>
							</StyledTableCell>
							<StyledTableCell>
								<DropdownInput
									value={payRecord.payType}
									onChange={handleChange("payType")}
									options={payType}
								/>
							</StyledTableCell>
							<StyledTableCell>
								<TextInputField
									value={payRecord.amount}
									onChange={handleChange("amount")}
								/>
							</StyledTableCell>

							<StyledTableCell>
								{!editting ? (
									<IconButton
										onClick={handleAddRecord}
										color="primary"
										component="label"
									>
										<AddRounded />
									</IconButton>
								) : (
									<IconButton
										onClick={() => handleSaveEdit(payRecord.payId)}
										color="primary"
										component="label"
									>
										<DoneRounded />
									</IconButton>
								)}
							</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{receivedPayments.length !== undefined &&
						receivedPayments.length > 0
							? receivedPayments.map((row, index) => (
									<StyledTableRow key={index}>
										<StyledTableCell component="th" scope="row">
											{row.serial || index}
										</StyledTableCell>
										<StyledTableCell>{row.payId}</StyledTableCell>
										<StyledTableCell>{row.payType}</StyledTableCell>
										<StyledTableCell>{row.amount}</StyledTableCell>
										<StyledTableCell
											sx={{ display: "flex", alignItems: "center" }}
										>
											<IconButton
												onClick={() => handleEditRecord(row.payId)}
												color="secondary"
												component="label"
											>
												<EditRounded sx={{ fontSize: 14 }} />
											</IconButton>
											<IconButton
												onClick={() => handleDeleteRecord(row.payId)}
												color="error"
												component="label"
											>
												<DeleteOutlineRounded sx={{ fontSize: 14 }} />
											</IconButton>
										</StyledTableCell>
									</StyledTableRow>
							  ))
							: null}
					</TableBody>
				</Table>
			</TableContainer>
			<FormControl
				component={Box}
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					padding: "0",
					paddingTop: ".5em",
					alignItems: "center",
				}}
			>
				<TextInputField
					defaultValue="Created By: Admin"
					InputProps={{
						readOnly: true,
					}}
				/>

				<TextInputField
					size="small"
					defaultValue="Current Login: Admin"
					InputProps={{
						readOnly: true,
					}}
				/>
			</FormControl>
		</>
	);
};

export default ScrapPaymentsTable;
